import React, { memo, useMemo } from "react";
import { icons } from "constants/icons";
import cn from "classnames";

type Props = {
  delta?: number;
  isBetter?: boolean;
};

export const ScoreDelta = memo(({ delta, isBetter }: Props) => {
  const icon = useMemo(() => {
    return isBetter ? icons.arrowUp : icons.arrowDown;
  }, [isBetter]);
  return (
    <div className="flex items-center space-x-0.5">
      <img src={icon} alt="arrow" />
      <strong
        className={cn("text-[12px] font-black", {
          "text-danger": !isBetter,
          "text-accent": isBetter,
        })}
      >
        {delta}
      </strong>
    </div>
  );
});
